<div id="ricercadiv" class="card card-w-title">
  <app-fulltext-search (search)="fulltextSearch($event)" (clear)="clearFulltextSearch()"></app-fulltext-search>

  <hr>

  <h3>Ricerca avanzata</h3>
  <div class="advanced-search">
    <app-position-select #posizioneSelector [fullyDisabled]="isDescrizioneFascicoloSelected() ? true : false"
      [(ngModel)]="positionDocSearch" #copiaSelect="ngModel">
    </app-position-select>
    <form [formGroup]="searchForm" (ngSubmit)="search()">
      <div class="grid">
        <div class="col-6">
          <label class="small-label" for="descrizioneFascicolo">Descrizione Fascicolo</label>
          <input pInputText autocomplete="off" type="text" [attr.disabled]="isFascicoloSelected() ? '' : null"
            formControlName="descrizioneFascicolo" id="descrizioneFascicolo" (keyup.enter)="search()"
            [ngClass]="isFascicoloSelected() ? 'disabled-input' : ''">
        </div>
        <div class="col-6">
          <label class="small-label" for="dataDocumento">Data Documento</label>
          <p-calendar formControlName="dataDocumento" inputId="dataDocumento" [selectOtherMonths]="true"
            dateFormat="dd/mm/yy" selectionMode="range" [showIcon]="true" [inputStyle]="{'width': '420px'}">
          </p-calendar>
        </div>
        <div class="col-6">
          <label class="small-label" for="protocollo">Protocollo</label>
          <input pInputText autocomplete="off" type="text" formControlName="protocollo" id="protocollo"
            (keyup.enter)="search()">
        </div>

        <div class="col-6">
          <label class="small-label" for="dataDocumento">Data Protocollo</label>
          <p-calendar formControlName="dataProtocollazione" inputId="dataProtocollo" [selectOtherMonths]="true"
            dateFormat="dd/mm/yy" selectionMode="range" [showIcon]="true" [inputStyle]="{'width': '420px'}">
          </p-calendar>
        </div>

        <div class="col-6">
          <label class="small-label" for="qualifica">Qualifica</label>
          <p-autoComplete [appAnagraficaAutocomplete]="AnagraficaQualificheService" #qualificaInput
            formControlName="qualifica" inputId="qualifica" tooltipPosition="left" [inputStyle]="{'width': '420px'}">
          </p-autoComplete>
        </div>

        <div class="col-6">
          <label class="small-label" for="classifica">Classifica</label>
          <p-autoComplete [appAnagraficaAutocomplete]="AnagraficaClassificheService" #classificaInput
            [qualifica]="qualificaInput.value" formControlName="classifica" inputId="classifica" tooltipPosition="left"
            [inputStyle]="{'width': '420px'}">
          </p-autoComplete>

          <div class="field-checkbox mt-1">
            <label class="small-label mr-1" for="esercitazione">Esercitazione</label>
            <p-checkbox [binary]="true" formControlName="esercitazione" inputId="esercitazione">
            </p-checkbox>
          </div>
        </div>

        <div [hidden]="!useSections()" class="col-6">
          <label class="small-label" for="sezione">Sezione</label>
          <p-autoComplete [suggestions]="sezioniFiltred" [inputStyle]="{'width': '420px'}" [dropdown]="true"
            (completeMethod)="searchSezione($event)" field="nomeSezione" tooltipPosition="left"
            formControlName="sezione" inputId="sezione">
          </p-autoComplete>
        </div>

        <div class="col-6">
          <label class="small-label" for="oggetto">Oggetto</label>
          <input pInputText autocomplete="off" type="text" placeholder="" formControlName="oggetto" id="oggetto">
        </div>

        <div class="col-6">
          <label class="small-label" for="statoUtente">Utente</label>
          <p-autoComplete formControlName="statoUtente" id="statoUtente" [suggestions]="utentiFiltrati"
            (completeMethod)="utentiFiltrati = autocompleteFilter($event, utenti, 'nomeUtente', true)" [dropdown]="true"
            [size]="20" [forceSelection]="false" [autoHighlight]="true" [inputStyle]="{'width': '420px'}"
            appendTo="body">
          </p-autoComplete>
        </div>

        <div class="col-6">
          <label class="small-label" for="autocompletemittente">Mittente/Destinatario</label>
          <p-autoComplete inputId="autocompletemittente" [originAutocomplete]="'ricercaAvanzataMittente'"
            [appAnagraficaAutocomplete]="AnagraficaIndirizziService" formControlName="mittente"
            [inputStyle]="{'width': '420px'}"></p-autoComplete>
        </div>

        <div class="col-6">
          <label class="small-label" for="stato">Stato</label>
          <p-autoComplete inputId="stato" [originAutocomplete]="'ricercaAvanzataStato'"
            [appAnagraficaAutocomplete]="AnagraficaStatiService" formControlName="stato"
            [inputStyle]="{'width': '420px'}"></p-autoComplete>
        </div>

        <div class="col-6">
          <label class="small-label" for="protmitt">Protocollo Mittente</label>
          <input pInputText autocomplete="off" type="text" formControlName="protmitt" id="protmitt">
        </div>

        <div class="col-6">
          <label class="small-label" for="contenuto">Contenuto</label>
          <input pInputText autocomplete="off" type="text" formControlName="contenuto" id="contenuto"
            (keyup.enter)="search()">
        </div>  
        <div class="col-6">
          <label class="small-label" for="allegato">Nome Allegato</label>
          <input pInputText autocomplete="off" type="text" formControlName="nomeAllegato" id="allegato"
            (keyup.enter)="search()">
        </div>

        <div class="col-12 buttons">
          <button pButton type="button" icon="fas fa-search" label="Cerca" title="Cerca" (click)="search()"
            [disabled]=" !searchForm.valid"></button>
          <button pButton type="button" icon="fas fa-eraser" label="Pulisci" title="Pulisci"
            (click)="clearForm()"></button>
        </div>
      </div>
    </form>
  </div>
</div>

<app-fulltext-viewer id="fulltextsearchresult" *ngIf="isFulltextSearch" [data]="searchFTResponse"
  [searchTerm]="highlighedTerms" [totalRecords]="totalRecords" (loadPage)="FullSearchPage($event)"
  [pageSize]="pageSize">
</app-fulltext-viewer>
<app-documenti-list id="searchresult" *ngIf="!isFulltextSearch" [showActionButtons]="true"
  (updateRequestAndSearch)="updateRequestAndSearch($event)" [data]="searchResponse" [activeColumns]="columns">
</app-documenti-list>
